module.exports = __webpack_public_path__ + "img/waiting.f434bc4d.png";